import { render, staticRenderFns } from "./activitiesDetail2021.vue?vue&type=template&id=602f9bdc&scoped=true"
import script from "./activitiesDetail2021.vue?vue&type=script&lang=js"
export * from "./activitiesDetail2021.vue?vue&type=script&lang=js"
import style0 from "./activitiesDetail2021.vue?vue&type=style&index=0&id=602f9bdc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "602f9bdc",
  null
  
)

export default component.exports